export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./faqs.vue?vue&type=template&id=a928279e&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/faqs.vue?vue&type=template&id=a928279e&
// module id = 82
// module chunks = 0